import * as diff from "fast-array-diff";
import { opStackCreate, opStackDelete } from "./opHelpers";

// Helper function that will generate a sequence of operations to convert
// oldList to newList. oldList and newList must contain scalar values.
function listDiffOps(oldList, newList) {
  const changes = diff.getPatch(oldList, newList);
  const ops = [];
  let offset = 0;
  let lastOldPos = -1;
  for (const change of changes) {
    if (change.oldPos <= lastOldPos) {
      throw new Error("listDiffOps assumes monotonically increasing oldPos");
    }
    lastOldPos = change.oldPos;
    if (change.type === "add") {
      for (let i = 0; i < change.items.length; i++) {
        ops.push(opStackCreate(change.oldPos + offset, change.items[i]));
        offset++;
      }
    } else if (change.type === "remove") {
      for (let i = 0; i < change.items.length; i++) {
        ops.push(opStackDelete(change.oldPos + offset + i, change.items[i]));
        offset--;
      }
    }
  }

  return ops;
}

export default listDiffOps;
